export default __webpack_public_path__ + "static/media/home-active.c7995d02.svg";